import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';

import { radiusTokens } from '@/theme/themePrimitives';

/** The invite card while the invite and the session load: logo, title, e-mail and the button. */
const InviteSkeleton = () => (
  <Stack alignItems="center" gap={1.5} aria-busy="true">
    <Skeleton variant="rounded" width={72} height={72} sx={{ borderRadius: '18px' }} />
    <Skeleton variant="text" width="70%" height={36} />
    <Skeleton variant="text" width="85%" />
    <Skeleton variant="text" width="60%" />
    <Skeleton
      variant="rounded"
      width="100%"
      height={44}
      sx={{ mt: 2, borderRadius: radiusTokens.pill }}
    />
  </Stack>
);

export default InviteSkeleton;
